import { useDispatch, useSelector } from 'react-redux';
import { useRefreshable } from './useRefreshable';
import { getLastEntries } from '../api/metricsService';

export const useLastMetrics = (systemId) => {
  const metricsInfo = useSelector(
    (state) => state.metricsReducer.lastEntries[systemId]
  );
  const dispatch = useDispatch();
  const refresh = useRefreshable(() => dispatch(getLastEntries(systemId)));
  if (metricsInfo) {
    return {
      lastMetrics: metricsInfo.systemMetrics,
      timeSinceLastReading: metricsInfo.timeSinceLastReading,
      loading: metricsInfo.loading,
      error: metricsInfo.error,
      refresh
    };
  }

  return {
    lastMetrics: [],
    timeSinceLastReading: Infinity,
    loading: true,
    error: false,
    refresh
  };
};
